import script from "./roles-permission.vue?vue&type=script&setup=true&lang=js"
export * from "./roles-permission.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__